import React, { Suspense, lazy, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import ScrollToTopButton from "./components/ScrollToTopButton";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./components/Home";

// Lazy Load Components
const BackgroundElements = lazy(() => import("./components/BackgroundElements"));
const HowItWorks = lazy(() => import("./components/HowItWorks"));
const KeyBenefits = lazy(() => import("./components/KeyBenifits"));
const Footer = lazy(() => import("./components/Footer"));

const PrivacyPolicy = lazy(() => import("./components/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("./components/TermsAndConditions"));
const ContactUs = lazy(() => import("./components/ContactUs"));

const ScrollToHash = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 500);
      }
    }
  }, [hash]);

  return null;
};

const LandingPage = React.memo(() => {
  return (
    <>
      <Header />
      <main>
        <ErrorBoundary>
          <Home />
          <Suspense fallback={null}>
            <HowItWorks />
            <KeyBenefits />
            <ContactUs showInLandingPage={true} />
            <Footer />
          </Suspense>
        </ErrorBoundary>
      </main>

      <ScrollToTopButton />
    </>
  );
});

const App = React.memo(() => {
  return (
    <Router>
      <ScrollToHash />
      <ErrorBoundary>
        <Suspense fallback={null}>
          <BackgroundElements />
        </Suspense>
      </ErrorBoundary>
      <div className="relative">
        <Routes>
          <Route path="/" element={<LandingPage />} />

          <Route path="/privacy" element={
            <Suspense fallback={<div>Loading...</div>}>
              <PrivacyPolicy />
            </Suspense>
          } />
          <Route path="/terms" element={
            <Suspense fallback={<div>Loading...</div>}>
              <TermsAndConditions />
            </Suspense>
          } />
          <Route path="/contact-us" element={
            <Suspense fallback={<div>Loading...</div>}>
              <ContactUs />
            </Suspense>
          } />
        </Routes>
      </div>
    </Router>
  );
});

export default App;
